/**
 * Converts an OpenTelemetry trace id (32 lowercase hex chars, as gorilla sends
 * it in the X-Wandb-Trace-Id response header) into the id Datadog keys that
 * trace by: the LOW 64 BITS of the OTel trace id, rendered as an unsigned
 * decimal string. See
 * https://docs.datadoghq.com/tracing/other_telemetry/connect_logs_and_traces/opentelemetry/?tab=go
 * and its deep link shape `https://<site>/apm/trace/<id>`.
 *
 * This mirrors gorilla's `convertTraceID` in
 * services/gorilla/pkg/observability/tracing/context.go: take the last 16 hex
 * chars (the low 64 bits), parse as base 16, format as base 10.
 *
 * Falls back to returning `id` unchanged when it doesn't look like a hex trace
 * id — we never want to blank out an Error Ref we can't parse.
 */
export function toDatadogTraceId(id: string): string {
  if (/^[0-9a-fA-F]{16,32}$/.test(id)) {
    return BigInt('0x' + id.slice(-16)).toString(10);
  }
  return id;
}
